import * as React from 'react';

import {Checkbox} from 'shells/checkbox/checkbox';
import {FormField} from 'shells/form/form-field';

type Props = {
    isStopOnLeadClosed: boolean;
    setIsStopOnLeadClosed: (arg1: boolean) => void;
};

export function StopOnLeadClosed(props: Props) {
    return (
        <FormField innerId='stop-on-lead-closed'>
            <div style={{marginTop: '16px'}}>
                <Checkbox
                    checked={props.isStopOnLeadClosed}
                    isLarge={true}
                    label='Stop sending when a related lead is closed'
                    onChange={(newValue) => {
                        props.setIsStopOnLeadClosed(newValue);
                    }}
                />
            </div>
        </FormField>
    );
}
